// lib/chat-types.ts
// Plain constants and types shared between app/actions/chat.ts (a "use server"
// file, which in this Next version may only export directly-defined async
// functions — no constants, no types) and client components that need them.

export const CHAT_MESSAGE_MAX_LENGTH = 500;
export const CHAT_PAGE_SIZE = 30;

export interface ChatMessageView {
  id: string;
  userId: string;
  displayName: string;
  body: string;
  createdAt: string;
  deleted: boolean;
  likeCount: number;
  likedByMe: boolean;
}
